<template>
  <div>
    <RouterView />
    <Notifications group="pipeline" position="bottom right" width="380" :duration="6000">
      <template #body="{ item, close }">
        <Notification :notification="item.data" dismissible @remove="close" />
      </template>
    </Notifications>
  </div>
</template>

<script setup>
  import { setLanguage } from '@/services/language.service';
  import { Notifications } from '@kyvg/vue3-notification';
  import Notification from '@/components/Notification.vue';
  setLanguage('fr')
</script>
